import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  isLoading: false,
  isInitStatus: false,
  countries: [],
  stepOneData: [],
  stepTwoData: [],
  stepThreeData: [],
  stepFourData: [],
  level:null
}

export default new Vuex.Store({

  state: state,
  mutations: {
    InitStatus(state) {
      state.isInitStatus = true;
      state.isLoading = false;
    },
    setLoading(state, value) {
      state.isLoading = value;
    },
    setCountries(state, value) {
      state.countries = value;
    },
    setStepOneData(state, value) {
      state.stepOneData = value;
    },
    setStepTwoData(state, value) {
      state.stepTwoData = value;
    },
    setStepThreeData(state, value) {
      state.stepThreeData = value;
    },
    setStepFourData(state, value) {
      state.stepFourData = value;
    },
    setLevel(state,value){
      state.level = value;
    }
  },
  actions: {

  },
  getters: {
    getAspirantData: state => {
      return [state.stepOneData, state.stepTwoData, state.stepThreeData]
    },
    getAspirantDataDocument: state => {
      return state.stepFourData;
    },
    getLevel: state =>{
      return state.level;
    }
  },
  modules: {
  }
})
